<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Payment Analysis",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Payment Analysis",
      items: [
        {
          text: "Account Section",
          href: "#/",
        },
        {
          text: "Payment Analysis",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        // {
        //   key: "branch",
        //   sortable: true,
        //   label: "BRANCH",
        // },
        {
          key: "patient_name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "PATIENT CONTACT",
        },
        {
          key: "date",
          sortable: true,
          label: "VISIT DATE",
        },
        {
          key: "cost",
          sortable: true,
          label: "TOTAL",
        },
        {
          key: "paid",
          sortable: true,
          label: "PAID",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        },
          {
          key: "services",
          sortable: true,
          label: "SERVICES",
        },
        {
          key: "patient_contact",
          sortable: true,
          label: "ACTION BY",
        },
      ],
      fitered_array: [],
      filterreport: {
        title: "PAYMENT ANALYSIS",
        today: moment(new Date()).format("YYYY-MM-DD"),
        date1: moment(new Date()).format("YYYY-MM-DD"),
        date2: moment(new Date()).format("YYYY-MM-DD"),
      },
      // FILTER

      rep_totals: {
        total_cal: "",
        total_paid: "",
        total_bala: "",
      },
      //   ============================= EXPORT ==============================
      json_fields: {
        BRANCH: "branch",
        NAME: "patient_name",
        PATIENT_CONTACT: "patient_contact",
        VISIT_DATE: "date",
        TOTAL_AMOUNT: "cost",
        PAID_AMOUNT: "paid",
        BALANCE: "balance",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  computed: {
    ...mapState("reports", ["payment_report"]),
    ...mapGetters("reports", ["PaymentReport"]),

    rows() {
      return this.fitered_array ? this.fitered_array.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.fitered_array ? this.fitered_array.length : 1;
  },
  watch: {
    payment_report(newValue) {
      if (newValue.length > 0) {
        this.payment_reportData();
      }
    },
  },
  methods: {
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    payment_reportData() {
      this.fitered_array = this.PaymentReport;
      let total_amt = 0;
      let total_pay = 0;
      this.fitered_array.forEach((value) => {
        var total1 = value.cost;
        var total2 = total1.replace(",", "");
        var total = parseInt(total2);
        total_amt = total_amt + total;
        // Calculate paid
        var paid1 = value.paid;
        var paid2 = paid1.replace(",", "");
        var paid = parseInt(paid2);
        total_pay = total_pay + paid;
      });
      this.rep_totals.total_cal = this.thousandSeprator(total_amt);
      this.rep_totals.total_paid = this.thousandSeprator(total_pay);
      this.rep_totals.total_bala = this.thousandSeprator(total_amt - total_pay);
      this.filter_report();
    },
    yes(data) {
      alert(data);
    },
    ...mapActions({
      FetchPaymentReport: "reports/fetchPaymentReport",
    }),

    // localizeDate(date) {
    //   if (!date || !date.includes("-")) return date;
    //   const [yyyy, mm, dd] = date.split("-");
    //   return new Date(`${mm}/${dd}/${yyyy}`);
    // },
    filter_report() {
      if (
        this.filterreport.date1 == this.filterreport.today &&
        this.filterreport.date2 == this.filterreport.today
      ) {
        this.filterreport.title = "PAYMENT ANALYSIS FOR TODAY";
      } else {
        this.filterreport.title =
          "PAYMENT ANALYSIS FROM " +
          this.filterreport.date1 +
          " TO " +
          this.filterreport.date2;
      }

      let startDate = this.filterreport.date1;
      let endDate = this.filterreport.date2;
      if (startDate != "" && endDate != "") {
        this.fitered_array = this.PaymentReport.filter((pymts) => {
          return pymts.date >= startDate && pymts.date <= endDate;
        });
      }

      let total_amt = 0;
      let total_pay = 0;
      this.fitered_array.forEach((value) => {
        var total1 = value.cost;
        var total2 = total1.replace(",", "");
        var total = parseInt(total2);
        total_amt = total_amt + total;
        // Calculate paid
        var paid1 = value.paid;
        var paid2 = paid1.replace(",", "");
        var paid = parseInt(paid2);
        total_pay = total_pay + paid;
      });
      this.rep_totals.total_cal = this.thousandSeprator(total_amt);
      this.rep_totals.total_paid = this.thousandSeprator(total_pay);
      this.rep_totals.total_bala = this.thousandSeprator(total_amt - total_pay);
    },
    addComma() {
      this.discount.amount = this.thousandSeprator(this.discount.amount);
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
  created() {
    this.payment_reportData();
    this.FetchPaymentReport();
  },
};
</script>
<style lang="css" scoped>
.compla {
  display: inline-flex;
  margin-right: 2px;
  padding: 2px;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h3 class="card-title mb-2 text-center" v-html="filterreport.title"></h3>
            <div class="row">
              <div class="col-md-6 form-group">
                <label>FROM</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date1"
                  type="date"
                  class="form-control m-1"
                />
              </div>
              <div class="col-md-6 form-group"> 
                <label>TO</label>
                <input
                  @change="filter_report()"
                  v-model="filterreport.date2"
                  type="date"
                  class="form-control m-1"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <download-excel
                  class="btn btn-primary mb-1"
                  :data="fitered_array"
                  :fields="json_fields"
                  :worksheet="'PAYMENT ANALYSIS FOR' + currentdate"
                  type="csv"
                  :name="'Payment_analysis_' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->

            <div class="table-responsive mb-0">
              <b-table
                foot-clone
                class="datatables"
                :items="fitered_array ? fitered_array : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
              
                </template>
                  <template #cell(services)="data"> 
  
                    <span
                      v-for="(service, index) in data.item.services"
                      :key="index"
                      ><span class="compla"
                        ><button type="button" class="btn btn-light btn-sm">
                          {{ service }}
                        </button></span
                      ></span
                    >
                </template>

                <template #cell(patient_name)="data">
                  {{ data.item.patient_name }}
                  <span
                    v-if="data.item.pay_type == 2"
                    class="badge rounded-pill bg-primary"
                    >Insurace</span
                  >
                  <span class="badge rounded-pill bg-success" v-else>personal</span>
                </template>
                <!-- <template #cell(actions)="data">
                  <button @clinc="yes(data)" class="btn btn-primary btn-sm">
                    Details
                  </button>
                </template> -->
                <template #foot(patient_name)="">
                  <span class="text-danger"></span
                ></template>
                <template #foot(date)=""> <span class="text-danger"></span></template>
                <template #foot(patient_contact)="">
                  <span class="text-danger"></span
                ></template>
                <template #foot(cost)="">
                  Total
                  <span class="text-info"> {{ rep_totals.total_cal }}</span>
                </template>

                <template #foot(paid)="">
                  Paid
                  <span class="text-primary"> {{ rep_totals.total_paid }}</span>
                </template>
                <template #foot(balance)="">
                  Balance <span class="text-warning"> {{ rep_totals.total_bala }}</span>
                </template>
                <template #foot(index)=""> <span>Totals</span></template>
              </b-table>
              <center>
                <h3 v-if="!PaymentReport" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
